import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TextWrapper1 = styled.div`
  width: ${(props) => props.width};
  display: block;
  .tag {
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #3e3f42;
    margin-bottom: 10px;
    text-transform: uppercase;
  }
  .data {
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #3e3f42;
  }
`;

const TextDataContacts = ({ tag, data, width }) => {
  return (
    <TextWrapper1 width={width}>
      <p className="tag">{tag}</p>
      <p className="data">{data}</p>
    </TextWrapper1>
  );
};

TextDataContacts.defaultProps = {
  tag: '',
  data: '',
  width: '50%',
};

TextDataContacts.propTypes = {
  tag: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  width: PropTypes.string,
};

export default TextDataContacts;
